import React, { useEffect, useState } from "react";
import { withPrefix } from "gatsby";
import styled from "styled-components";
import SupplyChainIndexItemFlags from "../baitToPlate/BaitToPlateIndexItemFlags";
import cleanCompanyName from "../../utilities/cleanCompanyName";

import Button from "../Button";
import FilterToggleControl from "../controls/FilterToggleControl";
import DiscussionInteractionCount from "./DiscussionInteractionCount";
import FilterPanels from "../controls/FilterPanels";
import FilterControls from "../controls/FilterControls";
import { useDiscussion } from "./DiscussionContext";
import DiscussionEntityLink from "./DiscussionEntityLink";
import cookie from "../../utilities/cookie";



const DiscussionFilters = ({ entity, entityType, filteredItems, setFilteredItems, getEntityHash, getEntityTitle, items, filtersOpenMobile, setFiltersOpenMobile, entityHasFlag  }) => {

  const { encodedFilters, setEncodedFilters } = useDiscussion();

  const itemsUniqueCountries = [...new Set(items.map((item) => item.country.name))].sort();
  
  const defaultActiveFilters = {
    flags: ["uyghur-labor", "north-korean-labor", "human-rights", "environmental", "flagging-in", "other"],
    type: ["co","org"],
    did_reply: undefined,
    countries: itemsUniqueCountries
  };

  const [activeFilters, setActiveFilters] = useState(defaultActiveFilters);

  function loadActiveFiltersFromURL() {
    const params = window.location.search;
    if ( params !== "" ) {
      const hashFilters = params.replace("?","").split("&");
      const newActiveFilters = {};
      hashFilters.forEach((filter) => {
        const filterParts = filter.split("=");
        newActiveFilters[filterParts[0]] = decodeURIComponent( filterParts[1] ).replace(/\+/g, " ").split(",");
      });
      if ( newActiveFilters.flags === undefined ) {
        newActiveFilters.flags = defaultActiveFilters.flags;
      }
      if ( newActiveFilters.type === undefined ) {
        newActiveFilters.type = defaultActiveFilters.type;
      }
      if ( newActiveFilters.did_reply === undefined ) {
        newActiveFilters.did_reply = defaultActiveFilters.did_reply;
      }
      if ( newActiveFilters.countries === undefined ) {
        newActiveFilters.countries = defaultActiveFilters.countries;
      }
      //console.log(newActiveFilters);
      setActiveFilters(newActiveFilters);
    }
    /*else if ( cookie("ooChinaDiscussionFilters") ) {
      const cookieFilters = cookie("ooChinaDiscussionFilters").split("&");
      const newActiveFilters = {};
      cookieFilters.forEach((filter) => {
        const filterParts = filter.split("=");
        newActiveFilters[filterParts[0]] = decodeURIComponent( filterParts[1] ).replace(/\+/g, " ").split(",");
      });
      setActiveFilters(newActiveFilters);
    }*/
  }

  useEffect(() => {
    loadActiveFiltersFromURL();
  }, []);
  
  useEffect(() => {

    const urlencodedActiveFilters = new URLSearchParams(activeFilters);

    if ( activeFilters?.flags?.length !== defaultActiveFilters?.flags?.length || activeFilters?.type?.length !== defaultActiveFilters?.type?.length || activeFilters?.did_reply !== defaultActiveFilters?.did_reply || activeFilters?.countries?.length !== defaultActiveFilters?.countries?.length) {

      setEncodedFilters(urlencodedActiveFilters);
      //cookie("ooChinaDiscussionFilters", urlencodedActiveFilters, 1);
    }
    else {
      /*const currentUrl = window.location.pathname + window.location.search;
      const newUrl = `${window.location.pathname}`;
      if ( currentUrl !== newUrl ) {
        window.history.pushState({}, '', newUrl);
      }*/
    }
  }, [activeFilters]); // TK defaultActiveFilters, setEncodedFilters

  const filterSections = [
    {
      type: "flags",
      name: "Crimes & Concerns, Topics",
      entityMatchFunction: entityHasFlag,
      filters: [
        {
          value: "uyghur-labor",
          label: "Uyghur Labor",
          count: items.filter((item, index) => entityHasFlag(item, "uyghur-labor") ).length,
          visibleCount: filteredItems.filter((item, index) => entityHasFlag(item, "uyghur-labor") ).length,
          caveat: entityType === "processor" ? undefined : true
        },
        {
          value: "north-korean-labor",
          label: "North Korean Labor",
          count: items.filter((item, index) => entityHasFlag(item, "north-korean-labor") ).length,
          visibleCount: filteredItems.filter((item, index) => entityHasFlag(item, "north-korean-labor") ).length,
          caveat: entityType === "processor" ? undefined : true
        },
        {
          value: "human-rights",
          label: "Human Rights & Labor",
          count: items.filter((item, index) => entityHasFlag(item, "human-rights") ).length,
          visibleCount: filteredItems.filter((item, index) => entityHasFlag(item, "human-rights") ).length,
          caveat: true
        },
        {
          value: "environmental",
          label: "Fishing & Environmental",
          count: items.filter((item, index) => entityHasFlag(item, "environmental") ).length,
          visibleCount: filteredItems.filter((item, index) => entityHasFlag(item, "environmental") ).length,
          caveat: true
        },
        {
          value: "flagging-in",
          label: "Flagging In",
          count: items.filter((item, index) => entityHasFlag(item, "flagging-in") ).length,
          visibleCount: filteredItems.filter((item, index) => entityHasFlag(item, "flagging-in") ).length,
          caveat: true
        },
        {
          value: "other",
          label: "General Inquiry",
          count: items.filter((item, index) => entityHasFlag(item, "other") ).length,
          visibleCount: filteredItems.filter((item, index) => entityHasFlag(item, "other") ).length,
          caveat: true
        }
      ]
    },
    {
      type: "type",
      name: "Type",
      entityMatchFunction: function(entity, type) {
        if ( type === "co" ) {
          return entity?.type === "co";
        }
        else if ( type === "org" ) {
          return entity?.type === "org";
        }
        return false;
      },
      filters: [
        {
          value: "co",
          label: "Companies",
          count: items.filter((item, index) => item?.type === "co" ).length,
          visibleCount: filteredItems.filter((item, index) => item?.type === "co" ).length,
          caveat: undefined,
          hint: "Fishing, Processing, Importing, Exporting, Retailing, Etc."
        },
        {
          value: "org",
          label: "Organizations",
          count: items.filter((item, index) => item?.type === "org" ).length,
          visibleCount: filteredItems.filter((item, index) => item?.type === "org" ).length,
          caveat: undefined,
          hint: "Auditing Bodies, NGOs, Government Agencies, Manning Agencies, Etc."
        }
      ]
    },
    {
      type: "did_reply",
      name: "Responsiveness",
      isBoolean: true,
      entityMatchFunction: function(entity, didReply) {
        if ( didReply === true ) {
          return entity?.count_replies > 0;
        }
        else {
          return true;
        }
      },
      filters: [
        {
          value: "yes",
          label: "At least one reply",
          count: items.filter((item, index) => item?.count_replies > 0 ).length,
          visibleCount: filteredItems.filter((item, index) => item?.count_replies > 0 ).length,
          caveat: undefined
        }
      ]
    },
    {
      type: "countries",
      name: "Countries",
      entityMatchFunction: function(entity, country) {
        return entity?.country?.name === country;
      },
      filters: itemsUniqueCountries.map((country, index) => {
        return {
          value: country,
          label: country,
          count: items.filter((item, index) => item?.country?.name === country ).length,
          visibleCount: filteredItems.filter((item, index) => item?.country?.name === country ).length,
          caveat: undefined
        }
      })
    }
  ];

  useEffect(() => {
    setFilteredItems(items);
    //setActiveFilters(defaultActiveFilters);
  }, [items]);



  return (
    <FilterPanels
      entity={entity}
      filtersContent={
        <FilterControls 
          items={items}
          setFilteredItems={setFilteredItems} 
          activeFilters={activeFilters} 
          setActiveFilters={setActiveFilters} 
          defaultActiveFilters={defaultActiveFilters} 
          filtersOpenMobile={filtersOpenMobile}
          setFiltersOpenMobile={setFiltersOpenMobile}
          entity={entity}
          entityHasFlag={entityHasFlag}
          filteredItems={filteredItems}
          filterSections={filterSections}
          filterTypeLabel="Stakeholders"
        />
      }
      listTitle="Stakeholders"
      listSlug={`/discussion/stakeholders/${encodedFilters ? `?${encodedFilters}` : ""}`}
      listItems={
        <>
          {filteredItems.map((item, index) => {

          return (
            <SupplyChainEntitySmallListItem key={index} entity={item} getEntityHash={getEntityHash} getEntityTitle={getEntityTitle} />
          )
          })}
        </>
      }
    />
  );
};

export default DiscussionFilters;


const SupplyChainEntitySmallListItem = ({ entity, getEntityHash, getEntityTitle }) => {
  
  return (
    <StyledSupplyChainEntitySmallListItem className={`is-${entity.type}`}>
      <div className="name-wrap">
        <div className="name">
          <DiscussionEntityLink entity={entity} />
        </div>
        {entity.name_mandarin && (<div className="name-mandarin">{entity.name_mandarin}</div>)}
      </div>
      <SupplyChainIndexItemFlags item={entity} isSmall={true} asSummary={true} />
      <div className="details">
        <div className="detail">{entity?.country?.name}</div>
      </div>
      <div className="interactions">
        <DiscussionInteractionCount inquiries={entity.count_inquiries} replies={entity.count_replies} isSmall={true} />
      </div>
      {/*<div className="details">
        {item.type === "vessel" && item.imo && (<div className="detail"><span className="detail-label">IMO: </span>{item.imo}</div>)}
        {item.country && (<div className="detail">{item.country}</div>)}
        {item.type === "processor" && isBoolean(item.is_msc_certified) && item.is_msc_certified && (
          <div className="detail cert">MSC Certified</div>
        )}
        {item.type === "processor" && isBoolean(item.is_eu_export_authorized) && item.is_eu_export_authorized && (
          <div className="detail cert">E.U. Export Authorized</div>
        )}
      </div>
        */}
    </StyledSupplyChainEntitySmallListItem>
  );
}

const StyledSupplyChainEntitySmallListItem = styled.li`
  padding: 1em 0;
  display: flex;
  flex-direction: column;
  gap: 0.5em;
  align-items: start;
  &:not(:last-of-type) {
    border-bottom: 1px solid rgba(255,255,255,0.2);
  }
  .name-wrap {
    display: flex;
    flex-direction: column;
    gap: 0.25em;
  }
  .name {
    font-size: 0.875em;
    font-weight: 700;
    line-height: 1.2;
    a {
      text-decoration-line: underline;
      text-decoration-thickness: 0.75px;
      text-underline-offset: 0.1em;
      text-decoration-color: rgba(255,255,255,0.4);
      .can-hover &:hover,
      &:active {
        text-decoration-color: currentColor;
      }
    }
  }
  .name-mandarin {
    font-size: 0.75em;
    font-weight: 500;
    opacity: 0.5;
  }
  .detail {
    font-size: 0.75em;
    font-weight: 500;
  }

`;